import Button from '@mui/material/Button';
import type { ApproverUserDto } from '@proposify/document-service-api-client';
import { useTranslation } from 'react-i18next';
import { ApprovalButtonVariant } from './approvalButtonVariant';
import { ApproveDocumentMenu } from './ApproveDocumentMenu';
import { RequestApprovalMenu } from './RequestApprovalMenu';

type NonShareVariant = Exclude<ApprovalButtonVariant, typeof ApprovalButtonVariant.SHARE>;

interface ApprovalActionButtonProps {
  variant: NonShareVariant;
  contentId: string;
  eligibleApprovers: ApproverUserDto[];
}

export function ApprovalActionButton({ variant, contentId, eligibleApprovers }: ApprovalActionButtonProps) {
  const { t } = useTranslation();

  if (variant === ApprovalButtonVariant.REQUEST_APPROVAL) {
    return <RequestApprovalMenu contentId={contentId} eligibleApprovers={eligibleApprovers} />;
  }

  if (variant === ApprovalButtonVariant.APPROVE_REQUEST) {
    return <ApproveDocumentMenu contentId={contentId} />;
  }

  return (
    <Button variant="contained" color="primary" className="approval-action-button">
      {t('share_document_v3.awaiting_approval_button')}
    </Button>
  );
}
